require('./cardRewardsTableRow.scss');

// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
const { connect } = require('react-redux');
const PureRenderMixin = require('react-addons-pure-render-mixin');
//@core
const { getLanguage } = require('core/i18n').i18n;
// @ helpers
const { DATE_FORMAT_DAY_MONTH_YEAR } = require('constants/index');
const { formatAmountObject, getPlainAmountObject } = require('utilities/currencyHelper');
const { formatDate } = require('utilities/dateHelper');
const { getLastNChars } = require('utilities/stringHelper');
// @ commons
const { FormattedText } = require('core/i18n').i18n;
const { OKTableCell } = require('commonsComponents/OKTableCell');
const { OKTableRow } = require('commonsComponents/OKTableRow');
const { OneLineSymbolAmount } = require('commonsComponents/oneLineSymbolAmount');

class CardRewardsTableRow extends React.Component {
    constructor(props){
        super(props);

        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
    }

    render() {
        const {
            id,
            immScreen,
            immTransaction,
        } = this.props;

        const plainAmountObject = getPlainAmountObject(immTransaction.get('amount'));
        const language = getLanguage();
        let amount,
            dateCell,
            description,
            paymentAccount;

        if (!!immTransaction) {
            amount = (
                <OneLineSymbolAmount
                    amountObject={plainAmountObject}
                    amountObjectFormatted={formatAmountObject(plainAmountObject, true)}
                    language={language}
                    positiveAmount={true}
                />
            );
            description = immTransaction.get('description');
            paymentAccount = immTransaction.getIn(['paymentAccount', 'bank'], '-')+getLastNChars(immTransaction.getIn(['paymentAccount', 'number'],''));
            dateCell = formatDate(immTransaction.get('date'), DATE_FORMAT_DAY_MONTH_YEAR);
        }

        let tableRow;

        if (immScreen.get('isMobile')) {
            tableRow = (
                <OKTableRow id={id}>
                    <OKTableCell className="card-rewards-table-row__cell-date">
                        <p className="card-rewards-table-row__paragraph-mobile card-rewards-table-row__paragraph-mobile--bold">
                            {dateCell}
                        </p>
                        <p className="card-rewards-table-row__paragraph-mobile card-rewards-table-row__paragraph-mobile--no-margin">
                            <FormattedText value="cardRewards-cardRewards_description" />
                        </p>
                        <p className="card-rewards-table-row__paragraph-mobile card-rewards-table-row__paragraph-mobile--no-margin">
                            <FormattedText value="cardRewards-cardRewards_paymentAccount" />
                        </p>
                        <p className="card-rewards-table-row__paragraph-mobile card-rewards-table-row__paragraph-mobile--no-margin">
                            <FormattedText value="cardRewards-cardRewards_amount" />
                        </p>
                    </OKTableCell>
                    <OKTableCell className="card-rewards-table-row__cell-amount card-rewards-table-row__cell-amount--mobile">
                        <p className="card-rewards-table-row__paragraph-mobile"></p>
                        <p className="card-rewards-table-row__paragraph-mobile card-rewards-table-row__paragraph-mobile--bold card-rewards-table-row__paragraph-mobile--no-margin">
                            {description}
                        </p>
                        <p className="card-rewards-table-row__paragraph-mobile card-rewards-table-row__paragraph-mobile--bold card-rewards-table-row__paragraph-mobile--no-margin">
                            {paymentAccount}
                        </p>
                        <p className="card-rewards-table-row__paragraph-mobile card-rewards-table-row__paragraph-mobile--bold card-rewards-table-row__paragraph-mobile--no-margin">
                            {amount}
                        </p>
                    </OKTableCell>
                </OKTableRow>
            );
        } else {
            tableRow = (
                <OKTableRow id={id}>
                    <OKTableCell className="card-rewards-table-row__cell-date">
                        {dateCell}
                    </OKTableCell>
                    <OKTableCell>
                        {description}
                    </OKTableCell>
                    <OKTableCell>
                        {paymentAccount}
                    </OKTableCell>
                    <OKTableCell className="card-rewards-table-row__cell-amount">
                        {amount}
                    </OKTableCell>
                </OKTableRow>
            );
        }

        return tableRow;
    }
}

CardRewardsTableRow.propTypes = {
    id: PropTypes.string,
    immTransaction: PropTypes.object,
    onRowClick: PropTypes.func,
    originCountry: PropTypes.string,
};

CardRewardsTableRow.defaultProps = {
    className: '',
    onRowClick: function() {},
};

CardRewardsTableRow.propTypes = {
    immScreen: PropTypes.object,
};

module.exports.constructor = CardRewardsTableRow;
module.exports.CardRewardsTableRow = connect(
    state => ({
        immScreen: state.screen,
        originCountry: state.profile.get('originCountry')
    }),
    null
)(CardRewardsTableRow);